import { render } from "./Booking_Right.vue?vue&type=template&id=98450162&scoped=true"
import script from "./Booking_Right.vue?vue&type=script&lang=js"
export * from "./Booking_Right.vue?vue&type=script&lang=js"

import "./Booking_Right.vue?vue&type=style&index=0&id=98450162&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98450162"]])

export default __exports__